import { mode_edit, mode_view } from '../../../../../../views/my-store/google-profile';

export default {
  title: 'Profil Google',
  sections: {
    current_profile: {
      [mode_view]: 'Połączony profil',
      [mode_edit]: 'Zmień połączony profil',
    },
  },
  form: {
    google_places_id: {
      label: 'Nazwa w Google Maps',
    },
    address: {
      label: 'Adres',
    },
    rating: {
      label: 'Ocena',
    },
    opening_hours: {
      label: 'Godziny otwarcia',
    },
    phone_number: {
      label: 'Numer telefonu',
    },
    pictures: {
      label: 'Zdjęcia',
    },
  },
  labels: {
    no_place_connected: 'Ta restauracja nie ma połączonego profilu Google',
    fields_to_sync: 'Informacje do synchronizacji z {{name}}',
  },
  buttons: {
    save: 'Zapisz',
    change: 'Zmień',
    cancel: 'Anuluj',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
